export default __webpack_public_path__ + "static/media/farsi.ab08e9ac.svg";